import styled from '@emotion/styled';

import Card from 'components/global/Card';

import Button from '../Button';

export const Miniscreen = styled(Card)`
	position: relative;
	width: 30rem !important;
	height: 20rem !important;
	transition: all 0.2s ease-in-out;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;

	:hover {
		> div {
			display: flex;
		}
	}

	> img {
		position: absolute;
		object-fit: contain;
		object-position: center;
	}
`;

export const DarkContainer = styled.div`
	z-index: 1;
	background-color: rgba(0, 0, 0, 0.5);
	display: none;
	position: absolute;
	justify-content: center;
	align-items: center;

	width: 100%;
	height: 100%;
`;

export const ModalContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 100%;
	padding: 2rem;

	> img {
		object-fit: contain;
		object-position: center;
	}

	.swiper {
		width: 100%;
		height: 100%;
	}
	.slider-navigation-left,
	.slider-navigation-right {
		position: absolute;
		z-index: 100000;
		top: 50%;
	}

	.slider-navigation-left {
		left: 0;
	}

	.slider-navigation-right {
		right: 0;
	}
`;

export const NavigationButtonStyled = styled(Button)`
	width: 5rem;
	height: 5rem;
	border-radius: 50%;
	background-color: var(--white) !important;
	border: 1px solid var(--border-color) !important;
	cursor: pointer;
	margin: 0 1rem;
	display: flex;
	justify-content: center;
	align-items: center;
	color: var(--black);

	&.disabled {
		opacity: 1;

		.icon {
			color: var(--black-40);
		}
	}
`;
